<!-- 上1主下4从模版 -->
<template>
  <div>
    <div class="box" id="box" ref="box">
      <div class="top" id="top">
        <el-main>
          <!-- {{ topHeight }} -->
          <data-tablec-new
            ref="master"
            @onLoad="getData"
            :height="topHeight || tableHeightFn()"
            :option="{
              searchHidden: zbParams.searchHidden,
              isTopDelete: zbParams.isTopDelete,
              isTopAdd: zbParams.isTopAdd,
              topButtonArea: zbParams.topButtonArea,
              tableHeight: topHeight || zbParams.tableHeight,
              // selection: false,
              exportBtn: true,
              filterBtn: false, // 取消高级筛选
              pageSize: 10,
            }"
            :colObj="{
              tableCellClick,
              addMasterSlaveClick,
              ...zbParams,
            }"
          >
            <template slot="TOP_BUTTON">
              <slot name="TOP_BUTTON"></slot>
            </template>
            <template slot="RIGHT_BUTTON">
              <slot name="RIGHT_BUTTON"></slot>
              <el-tooltip class="item" effect="dark" content="高级检索" placement="top">
                <el-button icon="iconfont icon-canshu" size="mini" circle @click="fliterClick"></el-button>
              </el-tooltip>
            </template>
            <template slot="menuLeft" slot-scope="{ row }">
              <slot name="menuLeft" :row="row"></slot>
            </template>
            <template slot="menuRight" slot-scope="{ row }">
              <slot name="menuRight" :row="row"></slot>
            </template>
            <template slot="searchSlot" slot-scope="{ query }">
              <slot name="searchSlot" :query="query"></slot>
            </template>
            <template slot="APPTIME" slot-scope="{ row }">
              <slot name="APPTIME" :row="row"></slot>
            </template>
            <template slot="top">
              {{tableName["zbTableName"]}}
              <slot name="top"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>
      <div class="resize" id="resize" title="收缩侧边栏">・・・</div>
      <div class="top" id="top">
        <el-main>
          <data-tablec-new
            ref="slave"
            @onLoad="getDataSlaveSun"
            :height="tableHeightFn()"
            :option="{
              // selection: false,
              exportBtn: false,
              // topFunctionButton: false,
              searchHidden: cbParams.searchHidden,
              isTopDelete: cbParams.isTopDelete,
              isTopAdd: cbParams.isTopAdd,
              topButtonArea: cbtopButtonArea && cbParams.topButtonArea,
              tableHeight: bottomHeight || cbParams.tableHeight,
              noLoad: true, // 表格不默认加载
              filterBtn: false, // 取消高级筛选
              pageSize: 5,
            }"
            :filterObj="{
              [zcbGlgx.chilProp]: glID,
            }"
            :colObj="{
              ...cbParams,
              tableCellSlaveSunClick,
              col: [],
              addForm: {
                [zcbGlgx.chilProp]: glID,
              },
            }"
          >
            <template slot="menuRight" slot-scope="{ row }">
              <slot name="menuRightSlave" :row="row"></slot>
            </template>
            <template slot="top">
              {{tableName["cbTableName"]}}
              <slot name="top"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>

      <div class="bottom" id="bottom">
        <el-main>
          <data-tablec-new
            ref="slave2"
            :height="tableHeightFn()"
            :option="{
              // selection: false,
              exportBtn: false,
              // topFunctionButton: false,
              searchHidden: cb2Params.searchHidden,
              isTopDelete: cb2Params.isTopDelete,
              isTopAdd: cb2Params.isTopAdd,
              topButtonArea: cb2topButtonArea && cb2Params.topButtonArea,
              tableHeight: bottomHeight || cb2Params.tableHeight,
              noLoad: true, // 表格不默认加载
              filterBtn: false, // 取消高级筛选
              pageSize: 5,
            }"
            :filterObj="{
              [zcbGlgx.chil2Prop]: glID,
            }"
            :colObj="{
              ...cb2Params,
              col: [],
              addForm: {
                [zcbGlgx.chil2Prop]: glID,
              },
            }"
          >
            <template slot="top">
              {{tableName["cb2TableName"]}}
              <slot name="top"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>

      <div class="bottom" id="bottom">
        <el-main>
          <data-tablec-new
            ref="sun"
            :splitUrl="splitUrl"
            :height="tableHeightFn()"
            :option="{
              // selection: false,
              exportBtn: false,
              // topFunctionButton: false,
              searchHidden: sunParams.searchHidden,
              topButtonArea: suntopButtonArea && sunParams.topButtonArea,
              isTopDelete: sunParams.isTopDelete,
              isTopAdd: sunParams.isTopAdd,
              tableHeight: bottomHeight || sunParams.tableHeight,
              noLoad: true, // 表格不默认加载
              filterBtn: false, // 取消高级筛选
              pageSize: 5,
            }"
            :filterObj="{
              [zcbGlgx.chilsunProp]: glSlaveSunID,
            }"
            :colObj="{
              ...sunParams,
              col: [],
              addForm: {
                [zcbGlgx.chilsunProp]: glSlaveSunID,
              },
            }"
          >
            <template slot="top">
              {{tableName["sunTableName"]}}
              <slot name="top"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>

      <div class="bottom" id="bottom">
        <el-main>
          <data-tablec-new
            ref="slave3"
            :height="tableHeightFn()"
            :option="{
              // selection: false,
              exportBtn: false,
              // topFunctionButton: false,
              searchHidden: cb3Params.searchHidden,
              isTopDelete: cb3Params.isTopDelete,
              isTopAdd: cb3Params.isTopAdd,
              topButtonArea: cb3topButtonArea && cb3Params.topButtonArea,
              tableHeight: bottomHeight || cb3Params.tableHeight,
              noLoad: true, // 表格不默认加载
              filterBtn: false, // 取消高级筛选
              pageSize: 5,
            }"
            :filterObj="{
              [zcbGlgx.chil3Prop]: glID,
            }"
            :colObj="{
              ...cb3Params,
              col: [],
              addForm: {
                [zcbGlgx.chil3Prop]: glID,
              },
            }"
          >
            <template slot="top">
              {{tableName["cb3TableName"]}}
              <slot name="top"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>

      <div class="bottom" id="bottom">
        <el-main>
          <data-tablec-new
            ref="slave4"
            :height="tableHeightFn()"
            :option="{
              // selection: false,
              exportBtn: false,
              // topFunctionButton: false,
              searchHidden: cb4Params.searchHidden,
              topButtonArea: cb4topButtonArea && cb4Params.topButtonArea,
              isTopDelete: cb4Params.isTopDelete,
              isTopAdd: cb4Params.isTopAdd,
              tableHeight: bottomHeight || cb4Params.tableHeight,
              noLoad: true, // 表格不默认加载
              filterBtn: false, // 取消高级筛选
              pageSize: 5,
            }"
            :filterObj="{
              [zcbGlgx.chil4Prop]: glID,
            }"
            :colObj="{
              ...cb4Params,
              col: [],
              addForm: {
                [zcbGlgx.chil4Prop]: glID,
              },
            }"
          >
            <template slot="top">
              {{tableName["cb4TableName"]}}
              <slot name="top"></slot>
            </template>
          </data-tablec-new>
        </el-main>
      </div>



    </div>

    <!-- 主从表分布式弹窗 -->
    <addMasterSlave-dialog
      :visible.sync="addMasterSlaveDialog"
      :masterAllOption="masterAllOption"
      :masterColObj="masterColObj"
      :masterAddForm="masterAddForm"
      :masterFormOption="masterFormOption"
      :slaveAllOption="slaveAllOption"
      :slaveColObj="slaveColObj"

      @closeClick="masterOnLoad"

    ></addMasterSlave-dialog>

    <!-- 过滤弹窗 -->
    <!-- {{ filterCtrl }} -->
    <filter-dialog :visible.sync="filterCtrl" @submit="filterSubmit" :column="filterColumn" :groupColumn="groupColumn" :colObj="{}" :isGroup="true"></filter-dialog>
  </div>
</template>

<script>
import AddMasterSlaveDialog from './AddMasterSlaveDialog';
import FilterDialog from '@/components/table/template/filterDialog';
import dataTablecNew from '@/components/table/dataTablecNew';
export default {
  components: { dataTablecNew, AddMasterSlaveDialog, FilterDialog },
  props: {
    splitUrl: {type: Object, default: {}},
    cb4isTopDelete: true,
    cb4isTopAdd: true,
    tableName: {type: Object, default: {}},

    title: {
      // 标题
      type: String,
      default: "",
    },
    zbParams: {
      // 主表参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        isTopDelete: false,
        isTopAdd: false,
      },
    },
    cbParams: {
      // 从表1参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        isTopDelete: false,
        isTopAdd: false,
      },
    },
    cb2Params: {
      // 从表2参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        isTopDelete: false,
        isTopAdd: false,
      },
    },
    cb3Params: {
      // 从表3参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        isTopDelete: false,
        isTopAdd: false,
      },
    },
    cb4Params: {
      // 从表4参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        isTopDelete: false,
        isTopAdd: false,
      },
    },
    sunParams: {
      // 孙表参数 opid， type 等
      type: Object,
      default: {
        searchHidden: false,
        topButtonArea: true,
        isTopDelete: false,
        isTopAdd: false,
      },
    },
    ljzParams: {
      // 懒加载参数
      type: Object,
      default: () => {},
    },
    zbShow: {
      // 主表展示字段
      type: String,
      default: "ID",
    },
    zcbGlgx: {
      // 主从表关联关系字段 parProp(主表字段) chilProp（从表字段）
      type: Object,
      default: () => {},
    },
    downMbObj: {
      type: Object,
      default: {},
    },
    cbHeight: 0,
  },
  data() {
    return {
      topHeight: 0, // 顶部的高度
      bottomHeight: 0, // 底部的高度
      filterCtrl: false, // 高级筛选控制显示隐藏
      filterColumn: [], // 高级筛选的属性
      groupColumn: [], // 高级筛选的属性

      addMasterSlaveDialog : false, // 新增主从数据弹框状态
      masterAllOption: {}, // 主表配置
      masterColObj: {}, // 主表配置
      masterAddForm: {}, // 主表表单
      masterFormOption: {}, // 主表表单配置
      slaveAllOption: {}, // 从表配置
      slaveColObj: {}, // 从表配置

      firstEnter: true,
      treeData: [],
      filterText: "",
      loading: false,
      cbtopButtonArea: true, // 从表顶部按钮
      cb2topButtonArea: true, // 从表2顶部按钮
      cb3topButtonArea: true, // 从表3顶部按钮
      cb4topButtonArea: true, // 从表4顶部按钮
      suntopButtonArea: true, // 孙表顶部按钮
      query: {
        ZGDWID: "",
        ZGDWMC: "",
      },
      glID: "",
      glSlaveSunID: "",
      selTags: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 高级筛选弹出
    fliterClick(){
      console.log(this.$refs.master.$refs.child.column);
      this.filterColumn = [
        ...this.$refs.master.$refs.child.column,
        ...this.$refs.slave.$refs.child.column,
        ...this.$refs.slave2.$refs.child.column,
        ...this.$refs.slave3.$refs.child.column,
        ...this.$refs.slave4.$refs.child.column,
      ]
      this.groupColumn = [
        {
          label: "主表属性",
          prop: "master",
          options: this.$refs.master.$refs.child.column,
        },
        {
          label: "从表1属性",
          prop: "slave",
          options: this.$refs.slave.$refs.child.column,
        },
        {
          label: "从表2属性",
          prop: "slave2",
          options: this.$refs.slave2.$refs.child.column,
        },
        {
          label: "从表3属性",
          prop: "slave3",
          options: this.$refs.slave3.$refs.child.column,
        },
        {
          label: "从表4属性",
          prop: "slave4",
          options: this.$refs.slave4.$refs.child.column,
        },
      ]
      console.log(this.filterColumn);
      this.filterCtrl=true;
    },
    //增加过滤条件按钮
    filterSubmit(params){
      this.filterCtrl=false;
      this.$refs.master.$refs.child.query.highSearch = params;
      console.log(this.$refs.master.$refs.child);
      this.$refs.master.$refs.child.onLoad();

      // this.query.highSearch=params;
      // 刷新
      // this.onLoad();
    },
    // 刷新主表
    masterOnLoad(){
      this.$refs.master.$refs.child.onLoad();
    },
    // 主从表新增
    addMasterSlaveClick(btn,row){
      //console.log("我是列啊啊啊啊啊："+this.$refs.master.$refs.child.column);
      // console.log(btn,row);
      //console.log("*****allOption*****"+this.$refs.slave.$refs.child.allOption);
      //console.log("*****colObj*****"+this.$refs.slave.$refs.child.colObj);

      this.masterAllOption = this.$refs.master.$refs.child.allOption;
      this.masterColObj = this.$refs.master.$refs.child.colObj;


      this.slaveAllOption = this.$refs.slave.$refs.child.allOption;
      console.log(this.slaveAllOption);
      this.slaveColObj = this.$refs.slave.$refs.child.colObj;

      let addList=[];
      let addform={};
      let column=this.deepClone(this.masterAllOption.column);
      for (let i = 0; i < column.length; i++) {
        const element = column[i];
        if(element.addDisplay===true){
          if(element.addDisabled===true){
            element.disabled=true;
          }
          addList.push(element);
        }
        if(element.value){
          addform[element.prop]=element.value;
        }
      }
      // console.log(addform,this.masterColObj.addForm,this.masterAddForm);
      this.masterAddForm = {...addform,...this.masterColObj.addForm};
      this.masterFormOption={
        type:'add',
        submitText: '下一步',
        styleType:'blue',
        column:addList,
        back: false,
      }
      this.$nextTick(()=>{
        this.addMasterSlaveDialog= true;
      })
    },
    addClick(empty){
      if(empty) this.addForm={};
      let addList=[];
      let addform={};
      let column=this.deepClone(this.allOption.column);
      for (let i = 0; i < column.length; i++) {
        const element = column[i];
        if(element.addDisplay===true){
          if(element.addDisabled===true){
            element.disabled=true;
          }
          addList.push(element);
        }
        if(element.value){
          addform[element.prop]=element.value;
        }
      }
      this.addForm = {...addform,...this.colObj.addForm,...this.addForm};
      this.formOption={
        type:'add',
        submitText: '保存',
        styleType:'blue',
        column:addList,
      }
      this.addDialog=true;
    },
    // 开始垂直拖动
    startDragV(e) {
      this.draggingV = true;
      this.startY = e.clientY;
      this.startTopHeight = this.topHeight;
      this.startBottomHeight = this.bottomHeight;
    },
    //获取第一级数据
    getData(data) {
      console.log("第一级数据："+data);
      console.log(data);
      // if (!this.$route.query.runId) return;
      // this.loading = true;
      // const res = await getShow(1, 20, this.$route.query.runId, {
      //   // extendTreeType: 2,
      //   ...this.zbParams,
      // });
      if (this.zcbGlgx.parProp) {
        if(data.length>0){
          this.glID = data[0][this.zcbGlgx.parProp];
          this.$nextTick(() => {
            this.$refs.slave.$refs.child.onLoad();
            this.$refs.slave2.$refs.child.onLoad();
            this.$refs.slave3.$refs.child.onLoad();
            this.$refs.slave4.$refs.child.onLoad();
          });
          this.cbtopButtonArea = this.cbParams.topButtonArea || true;
          this.cb2topButtonArea = this.cb2Params.topButtonArea || true;
          this.cb3topButtonArea = this.cb3Params.topButtonArea || true;
          this.cb4topButtonArea = this.cb4Params.topButtonArea || true;
        }else{
          this.cbtopButtonArea = false;
          this.$refs.slave.$refs.child.onLoad(true);
          this.cb2topButtonArea = false;
          this.$refs.slave2.$refs.child.onLoad(true);
          this.cb3topButtonArea = false;
          this.$refs.slave3.$refs.child.onLoad(true);
          this.cb4topButtonArea = false;
          this.$refs.slave4.$refs.child.onLoad(true);
        }
      } else {
        this.$message.warning("请绑定主从表关联主表字段！");
      }
      return
      this.treeData = res.data.data.records;
      if (this.treeData.length > 0 && this.treeData[0][this.zcbGlgx.parProp]) {
      } else {
        this.glID = "-1";
      }
      this.loading = false;
    },
    //获取Sun的slave数据
    getDataSlaveSun(data) {
      console.log("获取Sun的slave数据"+data);
      console.log(data);
      // if (!this.$route.query.runId) return;
      // this.loading = true;
      // const res = await getShow(1, 20, this.$route.query.runId, {
      //   // extendTreeType: 2,
      //   ...this.zbParams,
      // });
      if (this.zcbGlgx.chilIDProp) {
        if(data.length>0){
          this.glSlaveSunID = data[0][this.zcbGlgx.chilIDProp];
          this.$nextTick(() => {
            this.$refs.sun.$refs.child.onLoad();
          });
          this.suntopButtonArea = this.sunParams.topButtonArea || true;
        }else{
          this.suntopButtonArea = false;
          this.$refs.sun.$refs.child.onLoad(true);
        }
      } else {
        this.$message.warning("请绑定主从表关联主表字段！");
      }
      return
      this.treeData = res.data.data.records;
      if (this.treeData.length > 0 && this.treeData[0][this.zcbGlgx.parProp]) {
      } else {
        this.glID = "-1";
      }
      this.loading = false;
    },
    // 当某个单元格被点击时会触发该事件
    tableCellClick(row, column, cell, event) {
      console.log(row, column, cell, event);
      if (this.zcbGlgx.parProp) {
        this.glID = row[this.zcbGlgx.parProp];
        console.log(this.glID);
      } else {
        return this.$message.warning("请绑定主从表关联主表字段！");
      }
      // if(column.title !== "操作"){
        this.$nextTick(() => {
          this.$refs.slave.$refs.child.onLoad();
          this.$refs.slave2.$refs.child.onLoad();
          this.$refs.slave3.$refs.child.onLoad();
          this.$refs.slave4.$refs.child.onLoad();
        });
      // }

    },
    // 当某个单元格(从表1)被点击时会触发该事件（孙）
    tableCellSlaveSunClick(row, column, cell, event) {
      console.log(row, column, cell, event);
      if (this.zcbGlgx.chilIDProp) {
        this.glSlaveSunID = row[this.zcbGlgx.chilIDProp];
        console.log(this.glSlaveSunID);
      } else {
        return this.$message.warning("请绑定主从表关联主表字段！");
      }
      // if(column.title !== "操作"){
        this.$nextTick(() => {
          this.$refs.sun.$refs.child.onLoad();
        });
      // }

    },
    // 获取表格最大高度
    tableHeightFn(){
      let height = document.getElementById("avue-view");
      // console.log(height);
      if(height){
        if(height.clientHeight>=400){
          return height.clientHeight/2-20;
        }else{
          return 220
        }
      }
    },

    // 拖拉事件
    dragControllerDiv() {
      let _this = this;
      let resize = document.getElementById("resize");
      let top = document.getElementById("top");
      let bottom = document.getElementById("bottom");
      let box = document.getElementById("box");

      // 鼠标按下事件
      resize.onmousedown = function (e) {
        // 记录坐标起始位置
        let startY = e.clientY;

        // 左边元素起始宽度
        resize.top = top.offsetHeight;
        // console.log("高度：", resize.top);
        // 鼠标拖动事件
        document.onmousemove = function (e) {
          // 鼠标拖动的终止位置
          let endY = e.clientY;

          // （endx-startx）= 移动的距离
          //  resize.left + 移动的距离 = 左边区域最后的宽度
          let moveLen = resize.top + (endY - startY);
          // console.log(moveLen,this);



          // 左右两边区域的总宽度 = 大容器宽度 - 中间区域拖拉框的宽度
          let maxWidth = box.clientHeight - resize.offsetHeight;

          // 限制上边区域的最小高度为200px
          if (moveLen < 200){
            moveLen = 200;
          }
          
          _this.topHeight = moveLen - 20;

          // 右边区域最小宽度为 150px 限制左边区域到150后不能再拉宽
          // if (moveLen > maxWidth - 420) moveLen = maxWidth - 420;

          // 设置左边区域的宽度，通过换算为百分比的形式，实现窗体放大缩小自适应
          // console.log((moveLen / maxWidth) * 100);
          // top.style.width =(moveLen / maxWidth * 100) + '%';
          top.style.height = moveLen + "px";

          // 右边区域即是总大小 - 左边宽度 - 拖动条宽度
          // console.log(((maxWidth - moveLen) / maxWidth) * 100);

          // 先注释:  底下的高度不改变
          // bottom.style.height = maxWidth - moveLen + "px";
          // _this.bottomHeight = maxWidth - moveLen - 20;

          // console.log(moveLen);
        };
        // 鼠标松开事件
        document.onmouseup = function (evt) {
          // console.log(11);
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
        };
        resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
        return false;
      };
    },
  },
  mounted() {
    // this.getData();
    this.dragControllerDiv();
  },
  async activated() {
    // if (this.firstEnter) {
    //   this.firstEnter = false;
    // } else {
    //   await this.getData();
    //   this.$refs.table.$refs.child.onLoad();
    // }
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-icon-folder-opened,
/deep/.el-icon-folder {
  color: rgb(255, 192, 1) !important;
}

.aymc-item {
  flex: 1;
  padding-left: 7px;

  &:hover {
    color: #2e5ae8;
    cursor: pointer;
  }
}

.active-item {
  color: #2e5ae8;
}

/deep/.elx-table.has--tree-line .elx-tree--btn-wrapper,
/deep/.elx-table .elx-body--row.row--current {
  color: #3e34c9 !important;
}


/* 拖拽相关样式 */
.box {
  width: 100%;
  height: 100%;
  margin: 1% 0px;
  overflow: hidden;
  position: relative;
}
/*左侧div样式*/
.top {
  width: 100%;
  height: calc(50% - 10px); /*左侧初始化宽度*/
  // float: left;
}
/*拖拽区div样式*/
.resize {
  cursor: row-resize;
  // float: left;
  position: relative;
  // top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  // margin-top: 50px;
  width: 100%;
  height: 10px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 7px;
  text-align: center;
  color: white;
}
/*拖拽区鼠标悬停样式*/
.resize:hover {
  color: #444444;
}
/*底部div'样式*/
.bottom {
  float: left;
  width: 50%;
  height: 100%; /*右侧初始化宽度*/
}
</style>

